<template>
    <div class="userinfo clearfix">
        <div class="current">
            <p>当前位置：首页>我的报名</p>
        </div>
        <div class="menu">
            <center-menu active="3" />
        </div>
        <div class="content">
			<div class="title clearfix">
				<span class="lefts"></span><p>我的报名<span class="my-exam">&nbsp;&nbsp;/&nbsp;&nbsp;My application</span></p>
			</div>
			<div class="spdetail">
				<el-table
					:data="tableData"
					style="width: 100%"
					>
					<el-table-column
						prop="name"
						label="姓名"
						min-width="120px"
						>
					</el-table-column>
					<el-table-column
						label="报名级别"
						min-width="150px"
						>
						<template slot-scope="scope" >
							<span >{{scope.row.examType|testfilters}}</span>
						</template>
					</el-table-column>
					<el-table-column
						label="状态"
						min-width="80px"
						>
						<template slot-scope="scope" >
							<span >{{scope.row.aaastate}}</span>
						</template>
					</el-table-column>
					<el-table-column
						label="理由"
						prop="comment"
						min-width="150px"
						>
					</el-table-column>
					<el-table-column
						label="操作"
						min-width="120px"
						>
						<template slot-scope="scope" >
							<span v-if="scope.row.aaaanub == 3" @click="todo(scope.row)">完善信息</span>
							<span v-if="scope.row.aaaanub == 2" @click="enrollConfirm(scope.row)">确认考场</span>
							<span v-if="scope.row.aaaanub == 1" @click="searchcard(scope.row)">查询准考证</span>
							<span v-if="scope.row.aaaanub == 4" @click="todo(scope.row)">去修改</span>
							<span v-if="scope.row.aaaanub == 6 && !scope.row.enrollCode" @click="goToPay(scope.row.id)">去支付</span>
							<span v-else-if="scope.row.aaaanub == 5 || scope.row.aaaanub == 6" @click="tododetail(scope.row)">查看详情</span>
						 </template>
					</el-table-column>
				</el-table>	
				<pagination id="input" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />
				<ticket v-model="ticketShow" :bmInfo="bmInfo"/>
			</div>
        </div>
		<!-- <div class="searchcadi"></div> -->
    </div>
</template>

<script>
import { EnrollInfoListPage, examDetail } from '@/api/enroll'
import pagination from '@/components/pagination'
import ticket from '@/components/ticket'
export default {
    name: 'certificate',
    components: {
		pagination,
		ticket
    },
    data(){
        return {
			tableData: [],
			total:0,
			ticketShow: false,
			bmInfo: {},
			listQuery: {
			  	pageNum: 1,
			  	pageSize: 10,
				userId:this.$store.getters.userInfo.id,
				isSelf:1
			},
        }
    },
    mounted(){
		this.getList()
		console.log()
    },
    methods:{
    	goToPay(id){
			this.$router.push('/enroll/audit/' + id)
    	},
		todo(v){
			var x=this.$filters.testfilters(v.examType)
			this.$router.push(`/enroll/info/${x}/${v.id}`)
		},
		tododetail(v){
			this.$router.push(`/center/preview/${v.id}`)
		},
		enrollConfirm(v){
			this.$router.push(`/enroll/confirm/${v.id}`)
		},
		searchcard(v){
			examDetail({ tbInfoUserId: v.id }).then(res=>{
				console.log(res)
			    this.bmInfo = res.enrollInfo
			    this.examUserId = res.examUser.id
			    this.bmInfo.examRoomNo = res.examRoom.examRoomNo.toString().length==1?'0'+res.examRoom.examRoomNo:res.examRoom.examRoomNo
                this.bmInfo.examRoomNo = res.examRoom.province+this.bmInfo.examRoomNo
			    this.bmInfo.level = this.$filters.testfilters(res.enrollInfo.examType)
			    this.bmInfo.addr = res.examRoom.province + res.examRoom.city + res.examRoom.region + '-' + res.examRoom.address
			    if(res.enrollCompanys[0]&&res.enrollCompanys[0].companyName){
			        this.bmInfo.gzorby = res.enrollCompanys[0].companyName
			    }else if(res.enrollstu){
			        this.bmInfo.gzorby = res.enrollstu.universityName
			    }else{
					this.bmInfo.gzorby = res.enrollgrad.collegeName
				}
			    this.bmInfo.examTime = this.$filters.dateTime(res.exam.examTime, 'yyyy年MM月dd日 ') + res.exam.examHourStart + '' + res.exam.examHourEnd
			    // this.bmInfo.examTime = this.$filters.dateTime(res.exam.examHourStart, 'yyyy年MM月dd日，hh:mm') + '-' + this.$filters.dateTime(res.exam.examHourEnd, 'hh:mm')
			    this.bmInfo.permitNum = res.examUser.permitNum
			    this.ticketShow = true
			})
		},
		getList(){
			EnrollInfoListPage(this.listQuery).then(res=>{
				this.total=res.total
				console.log(res)
				res.list.forEach((val,index)=>{
					this.satatfilaters(val)
				})
				this.tableData=res.list
			})
		},
		satatfilaters(res) {
			let {confirm,examRoomId,pass,enrollCode} = res
			console.log(enrollCode)
	　　　　	if(confirm==1){
				if(examRoomId){
					res.aaaanub = 2
					res.aaastate = '已分配考场'
				}else{
					if(pass || pass == 0){
						res.aaaanub = pass+5
						res.aaastate = ['审核未通过','审核中','审核通过'][pass+1]
						if(pass==1&&enrollCode){
							res.aaastate = '待分配考场'
						}
					}else{
						res.aaaanub = 3
						res.aaastate = '暂存'
					}
				}
			}else{
				if(confirm==2){
					res.aaaanub = 1
				}
				res.aaastate = ['已确认考场','已延期','已撤销'][confirm-2]
			}
	　　}　
    }
}
</script>

<style scoped>
    .menu{float: left;width: 170px;}
    .content{float: right;width: 1028px;}
	.lefts {width: 5px;height: 24px;background:#a52821;float: left;}
	.title p {float: left; color:#a52821;font-size: 18px;line-height: 24px;margin-left: 10px;font-weight: bold;}
	.title .my-exam {font-size: 14px; color: #999999;font-weight: normal;}
	.spdetail >>>.el-table__row span {cursor: pointer;}
	#input >>>.el-input {width: 55px;}
	.searchcadi{position: absolute;z-index: 99999;}
</style>
